import {
    SYSTEM_CHOOSE_CURRENT_SALARYRANGE,
} from './constants';
  
export function chooseCurrentSalaryRange(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_SALARYRANGE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_SALARYRANGE:
        return {
          ...state,
          currentSalaryRange:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentSalaryRange.js